export default __webpack_public_path__ + "f51a24f4ed3bfce1b3d18ce480d68d24.otf";